export function getMonthShortNames() {
  return Array.from({ length: 12 }, (_, i) =>
    // The year doesn't matter, it's just a placeholder
    new Intl.DateTimeFormat('en-US', { month: 'short' }).format(new Date(2020, i)),
  )
}
